import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useContext } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { createStore } from 'zustand/vanilla';
export function createContext(defaultState) {
    const Ctx = React.createContext(createStore(() => defaultState));
    const Provider = ({ value, children }) => {
        const storeRef = useRef();
        // initialize the store if it's not already initialized
        if (!storeRef.current) {
            const store = createStore(() => value);
            storeRef.current = store;
        }
        React.useLayoutEffect(() => {
            var _a;
            // use setState(prev => newValue) instead of setState(newValue)
            // to ensure that the state is updated correctly even when the value is a function
            // previously when function was passed, it used to call the function and set the returned value as new state which caused issues.
            (_a = storeRef.current) === null || _a === void 0 ? void 0 : _a.setState(() => value, true);
        }, [value]);
        const contextValue = storeRef.current;
        return _jsx(Ctx.Provider, { value: contextValue, children: children });
    };
    return { Context: Ctx, Provider };
}
export function useContextSelector(Context, selector, equalityFn = Object.is) {
    const store = useContext(Context);
    return useStoreWithEqualityFn(store, selector, equalityFn);
}
